/* eslint-disable */
import XLSX from "xlsx-js-style";
import excelWorker from "./excelWorker";

class excel {
  static maxRowToGenerate = 10000;
  static maxMinLength = 100000;
  static maxThread = 4;

  static excelOptions = {};

  static async generateAsync(data, options, useThread) {
    //#region Default options
    if (!options) { options = {} }
    if (options['fitCol'] == undefined) { options['fitCol'] = false }
    if (options['title'] == undefined) { options['title'] = 'Generated_Excel' }
    if (options['rowHighlight'] == undefined) { options['rowHighlight'] = false }
    if (options['tableTheme'] == undefined) { options['tableTheme'] = { header: null, row: null } }
    else { options['tableTheme'] = {
      header: this.rgbaToExcelColor(options['tableTheme']),
      row: this.rgbaToExcelColor(options['tableTheme'].split(',').map(r => {
        let val = Number(r);
        if (val == 255) { return 255 }
        else {
          return val + 120 > 225 ? 225 : val + 120 < 175 ? 175 : val + 120;
        }
      }).join(','))
    } }
    if (options['rightAlign'] == undefined) { options['rightAlign'] = [] }

    this.excelOptions = options;
    //#endregion

    //#region Reformat Colors
    let strExcelData = JSON.stringify(data);
    let allColors = strExcelData.match(/('|")(\d{1,3}),(\d{1,3}),(\d{1,3})(,[0-1]\.?(\d{1,})?)?('|")/g);
    if (allColors) {
      allColors.forEach(c => strExcelData = strExcelData.replace(c, JSON.stringify(this.rgbaToExcelColor(c))));
    }
    data = JSON.parse(strExcelData);
    //#endregion

    //#region Init Excel
    let wb = XLSX.utils.book_new();
    let ws = null;
    //#endregion

    //#region Populate Excel Cell
    if (useThread == undefined) { useThread = true }
    if (useThread) {
      console.log('using thread');
      try {
        let worksheet = await this.populateCellAsync(data);
  
        let cellPositionArray = worksheet.map(r => r['!ref']).map(r => {
          if (r.includes(':')) {
            let range = XLSX.utils.decode_range(r);
            return [ range['s'], range['e'] ];
          } else {
            return XLSX.utils.decode_cell(r);
          }
        }).flat();
        let maxCol = Math.max(...cellPositionArray.map(c => c['c']));
        let maxRow = Math.max(...cellPositionArray.map(c => c['r']));
  
        ws = Object.assign({}, ...worksheet);
        ws['!ref'] = `A1:${XLSX.utils.encode_cell({ c: maxCol, r: maxRow })}`;
        
        XLSX.utils.book_append_sheet(wb, ws);
      } catch (e) {
        console.log('has error', e);
        return;
      }
    } else {
      console.log('not using thread');
      ws = XLSX.utils.aoa_to_sheet([]);
      XLSX.utils.book_append_sheet(wb, ws);
      data.forEach(e => {
        if (Array.isArray(e['value'])) {
          let cell = XLSX.utils.decode_cell(e['cell']);
          let header = Object.keys(e['value'][0]);
          header.forEach(h => {
            XLSX.utils.sheet_add_aoa(ws, [[h || '']], { origin: cell });
            ws[XLSX.utils.encode_cell(cell)].s = e['headerStyle'];
            if (!ws[XLSX.utils.encode_cell(cell)].s) { ws[XLSX.utils.encode_cell(cell)].s = {} }
            if (options['tableTheme']['header']) {
              ws[XLSX.utils.encode_cell(cell)].s['fill'] = {
                fgColor: options['tableTheme']['header']
              };
            }
            cell['c']++;
          });
  
          cell['r']++;
          cell['c'] -= header.length;
          e['value'].forEach((v, i) => {
            let values = Object.values(v);
            values.forEach(val => {
              XLSX.utils.sheet_add_aoa(ws, [[val || '']], { origin: cell });
              if (options['rowHighlight'] && (i % 2 == 0)) {
                ws[XLSX.utils.encode_cell(cell)].s = {
                  fill: {
                    fgColor: options['tableTheme']['header'] || this.rgbaToExcelColor('226,228,255')
                  }
                }
              }
              cell['c']++;
            });
            
            cell['r']++;
            cell['c'] -= header.length;
          })
        } else {
          XLSX.utils.sheet_add_aoa(ws, [[e['value'] || '']], { origin: e['cell'] });
          if (e['style']) {
            ws[e['cell']].s = e['style'];
          }
        }
      });
    }
    //#endregion
    
    //#region Merging Cell (if any)
    let hasMerge = data.filter(e => e['merge']);
    let merge = hasMerge.map(m => {
      let colRow = XLSX.utils.decode_cell(m['cell']);
      let col = colRow['c'];
      let row = colRow['r'];

      let colSpan = m['merge']['col'] ? m['merge']['col'] - 1 : 0;
      let rowSpan = m['merge']['row'] ? m['merge']['row'] - 1 : 0;

      return { s: { r: row, c: col }, e: { r: row + rowSpan, c: col + colSpan } }
    });
    ws["!merges"] = merge;
    //#endregion
    
    //#region Drawing the border
    let borders = data.filter(e => e['border']);
    borders.forEach(b => {
      if (b['merge']) {
        let colRow = XLSX.utils.decode_cell(b['cell']);
        let startCol = colRow['c'];
        let startRow = colRow['r'];
        let endCol = startCol + (b['merge']['col'] > 0 ? b['merge']['col'] - 1 : 0);
        let endRow = startRow + (b['merge']['row'] > 0 ? b['merge']['row'] - 1 : 0);
        
        let topCells = [];
        let rightCells = [];
        let bottomCells = [];
        let leftCells = [];

        for (let x = startCol; x <= endCol; x++) {
          topCells.push({ c: x, r: startRow });
          bottomCells.push({ c: x, r: endRow });
        }
        
        for (let x = startRow; x <= endRow; x++) {
          leftCells.push({ c: startCol, r: x });
          rightCells.push({ c: endCol, r: x });
        }

        if (b['border']['top']) {
          topCells.forEach(c => {
            let cellString = XLSX.utils.encode_cell(c);
            if (!ws[cellString]) { XLSX.utils.sheet_add_aoa(ws, [['']], { origin: cellString }) } // Create the cell object if empty
            if (!ws[cellString]['s']) { ws[cellString].s = {} } // Create the style object if it is empty
            if (!ws[cellString].s['border']) { ws[cellString].s['border'] = {} } // Crete the border object if empty
            ws[cellString].s['border']['top'] = b['border']['top'];
          });
        }
        if (b['border']['right']) {
          rightCells.forEach(c => {
            let cellString = XLSX.utils.encode_cell(c);
            if (!ws[cellString]) { XLSX.utils.sheet_add_aoa(ws, [['']], { origin: cellString }) } // Create the cell object if empty
            if (!ws[cellString]['s']) { ws[cellString].s = {} } // Create the style object if it is empty
            if (!ws[cellString].s['border']) { ws[cellString].s['border'] = {} } // Crete the border object if empty
            ws[cellString].s['border']['right'] = b['border']['right'];
          });
        }
        if (b['border']['bottom']) {
          bottomCells.forEach(c => {
            let cellString = XLSX.utils.encode_cell(c);
            if (!ws[cellString]) { XLSX.utils.sheet_add_aoa(ws, [['']], { origin: cellString }) } // Create the cell object if empty
            if (!ws[cellString]['s']) { ws[cellString].s = {} } // Create the style object if it is empty
            if (!ws[cellString].s['border']) { ws[cellString].s['border'] = {} } // Crete the border object if empty
            ws[cellString].s['border']['bottom'] = b['border']['bottom'];
          });
        }
        if (b['border']['left']) {
          leftCells.forEach(c => {
            let cellString = XLSX.utils.encode_cell(c);
            if (!ws[cellString]) { XLSX.utils.sheet_add_aoa(ws, [['']], { origin: cellString }) } // Create the cell object if empty
            if (!ws[cellString]['s']) { ws[cellString].s = {} } // Create the style object if it is empty
            if (!ws[cellString].s['border']) { ws[cellString].s['border'] = {} } // Crete the border object if empty
            ws[cellString].s['border']['left'] = b['border']['left'];
          });
        }
      } else {
        if (!ws[b['cell']].s) { ws[b['cell']].s = {} }
        ws[b['cell']].s['border'] = b['border'];
      }
    })
    //#endregion
    
    //#region Set Column Width based on characters
    if (options['fitCol']) {
      let allCellAddress = Object.keys(ws).filter(c => !c.includes('!')).map(c => XLSX.utils.decode_cell(c));
      let cols = [...new Set(allCellAddress.map(a => a['c']))];
      let minRow = 0; 
      let maxRow = 0;
      let colWidth = [];
      
      const dataStartRowOffset = 2; 
      if (useThread) {
        let maxmin = await this.getMaxMin(allCellAddress.map(a => a['r']));
        minRow = maxmin['min'] + dataStartRowOffset;
        maxRow = maxmin['max'];
        colWidth = Array((await this.getMaxMin(allCellAddress.map(a => a['c'])))['max']).fill('');
      } else {
        minRow = Math.min(...allCellAddress.map(a => a['r'])) + dataStartRowOffset;
        maxRow = Math.max(...allCellAddress.map(a => a['r']));
        colWidth = Array(Math.max(...allCellAddress.map(a => a['c']))).fill('');
      }
      // The first column is taking the first row(title), as it's longest col width. Skip first row with +2
      
      let colWidthObj = [];

      cols.forEach(c => {
        if (c < 0) { return }
        
        let colValueLength = [];
        for (let i = minRow; i <= maxRow + 1; i++) {
          let cell = `${XLSX.utils.encode_col(c)}${i}`;
          colValueLength.push(ws[cell] ? ws[cell].v.toString().length : 0)
        }

        colWidthObj.push({
          index: c,
          length: colValueLength.reduce((max, v) => (v > max ? v : max), 0),
        });
      });
      
      colWidthObj.forEach(i => colWidth[i['index']] = i['length'] > 0 ? { wch: i['length'] } : '');
      ws['!cols'] = colWidth;
    }
    //#endregion
    
    //#region Formula Section (NOT YET IMPLEMENTED)
    // ws['C9'] = {
    //   f: 'SUM(C6:C8)'
    // };
    // XLSX.utils.sheet_add_aoa(ws, [['=SUM(C6:C8)']], { origin: `C9` });
    // ws['C9'].f = 'SUM(C6:C8)';
    //#endregion

    XLSX.writeFile(wb, `${options['title']}.xlsx`);
  }

  static populateCellAsync(data) {
    return new Promise(async (res, rej) => {
      let valueIsArray = data.filter(d => Array.isArray(d['value']));
      let valueNotArray = data.filter(d => !Array.isArray(d['value']));
      let workerResult = [];

      //#region Formatting and generating the table
      // if (valueIsArray.length > 1) {
      //   rej('We only support 1 table per sheet at the moment');
      //   return;
      // }

      let formatedArray = valueIsArray.map(v => {
        let tableValueSplit = [];
        while (v['value'].length > 0 || v['value'].length > this.maxRowToGenerate) {
          tableValueSplit.push(v['value'].splice(0, this.maxRowToGenerate));
        }
        
        let tableValueToWorker = [];
        while (tableValueSplit.length > 0 || tableValueSplit.length > this.maxThread) {
          tableValueToWorker.push(tableValueSplit.splice(0, this.maxThread));
        }
        
        delete v['value'];

        return {
          formatedValues: tableValueToWorker,
          details: v
        }
      });

      for (let f of formatedArray) {
        let valueIndex = 0;
        for (let w of f['formatedValues']) {
          let workers = w.map((wd, wdi) => {
            return { 
              data: { value: wd, ...f['details'], startRow: (valueIndex * (this.maxRowToGenerate * this.maxThread)) + (wdi * this.maxRowToGenerate) },
              worker: new excelWorker().createWorker()
            }
          });
          workerResult.push(await this.startWorker(workers));
          valueIndex++;
        }
      }
      //#endregion
      
      //#region Formatting and generating single cell value
      let valueNotArraySplit = [];
      while (valueNotArray.length > 0 || valueNotArray.length > this.maxRowToGenerate) {
        valueNotArraySplit.push(valueNotArray.splice(0, this.maxRowToGenerate));
      }
      
      let valueNotArrayToWorker = [];
      while (valueNotArraySplit.length > 0 || valueNotArraySplit.length > this.maxThread) {
        valueNotArrayToWorker.push(valueNotArraySplit.splice(0, this.maxThread));
      }

      let notArrayWorkers = valueNotArrayToWorker.map(na => {
        return {
          data: na.flat(),
          worker: new excelWorker().createWorker()
        }
      });
      
      workerResult.push(await this.startWorker(notArrayWorkers));
      //#endregion
      
      res(workerResult.flat());
    });
  }

  static startWorker(data) {
    return new Promise(res => {
      let result = [];
      if (data.length == 0) {
        res([]);
      } else {
        data.forEach(d => {
          d['worker'].postMessage({ data: d['data'], options: this.excelOptions });
          d['worker'].onmessage = (e) => {
            result.push(e.data);
            if (result.length == data.length) {
              //#region Table header styling
              let sheet = result.map(r => r['sheet']);
              let headerDetails = result.find(r => r['header']);
              
              if (headerDetails) {
                let cell = XLSX.utils.decode_cell(headerDetails['cell']);
                let headerSheet = XLSX.utils.aoa_to_sheet([]);
                headerDetails['header'].forEach(h => {
                  XLSX.utils.sheet_add_aoa(headerSheet, [[h || '']], { origin: cell });
                  if (!headerSheet[XLSX.utils.encode_cell(cell)].s) { headerSheet[XLSX.utils.encode_cell(cell)].s = {} }
                  if (headerDetails['headerStyle']) { headerSheet[XLSX.utils.encode_cell(cell)].s = headerDetails['headerStyle'] }
                  else { headerSheet[XLSX.utils.encode_cell(cell)].s = {} }
                  if (this.excelOptions['tableTheme']) {
                    headerSheet[XLSX.utils.encode_cell(cell)].s['fill'] = {
                      fgColor: this.excelOptions['tableTheme']['header']
                    }
                  }
                  cell['c']++;
                })
                sheet.push(headerSheet);
              }
              //#endregion
              
              res(sheet);
            }
          }
        });
      }
    });
  }

  static rgbaToExcelColor(value) {
    value = value.replace(/"/g, "");
    let [r, g, b, a] = value.split(",").map((v) => (v ? Number(v) : 0));
    r = r ? r.toString(16) : (0).toString(16);
    g = g ? g.toString(16) : (0).toString(16);
    b = b ? b.toString(16) : (0).toString(16);
    a = Math.round(a ? (a > 1 ? 255 : a * 255) : 1 * 255).toString(16);

    return {
      rgb: `${a.length == 1 ? `0${a}` : a}${r.length == 1 ? `0${r}` : r}${g.length == 1 ? `0${g}` : g
        }${b.length == 1 ? `0${b}` : b}`,
    };
  }

  static getMaxMin(nums) {
    let numsSplit = [];
    while(nums.length > 0 || nums.length > this.maxMinLength) {
      numsSplit.push(nums.splice(0, this.maxMinLength));
    }

    let numsToWorker = [];
    while (numsSplit.length > 0 || numsSplit.length > this.maxThread) {
      numsToWorker.push({
        values: numsSplit.splice(0, this.maxThread),
        worker: new excelWorker().createMaxMinWorker()
      });
    }
    
    return new Promise(res => {
      let allValues = [];
      for (let w of numsToWorker) {
        w['worker'].postMessage(w['values']);
        w['worker'].onmessage = (e) => {
          allValues.push(e.data);
          if (allValues.length == numsToWorker.length) {
            res({
              max: Math.max(...allValues.map(a => a['max'])),
              min: Math.min(...allValues.map(a => a['min'])),
            })
          }
        }
      }
    })
  }
}

export default excel;